module.exports = __webpack_public_path__ + "static/media/dytronix.11ec8e52.png";